//Core
import React from "react"

//style
import "./index.scss"

const Block = ({ img, title, subtitle, titleStyle, size }) => {
  return (
    <div
      className={`uah_block ${size === "middle" ? "_middle" : ""} 
      ${size === "small" ? "small" : ""}`}
    >
      <img src={img} alt={title + "| Таскомбанк"}></img>
      <div className="text">
        <h2
          style={titleStyle}
          style={{
            color: "#001e61",
            fontWeight: "900",
            fontSize: "18px",
            fontFamily: "Roboto",
            fontStretch: "normal",
            fontStyle: "normal",
            lineHeight: "normal",
            letterSpacing: "normal",
          }}
        >
          {title}
        </h2>
        {subtitle.map(item => (
          <div className={`${size === "small" ? "small" : ""}`}>{item}</div>
        ))}
      </div>
    </div>
  )
}

export default Block
